<ion-menu
    contentId="{{ contentID }}"
    (ionWillOpen)="onMenuOpen()">
    <ion-content>
        <ion-menu-toggle auto-hide="false">
            @if (!(roles?.length > 0)) {
                <ion-item
                    class="pointer"
                    (click)="login()">
                    <ion-label
                        class="menu-item"
                        style="font-weight: bold"
                        color="primary">
                        {{ 'LOGIN' | translate }}
                    </ion-label>
                </ion-item>
            }
        </ion-menu-toggle>
        @for (
            pageConfig of configService.frontendConfig().pageConfigs
                | MenuItemsFilter: roles : configService.frontendConfig().features : configService.config();
            track pageConfig.pageId
        ) {
            <span (click)="openPage(pageConfig.url)">
                <ion-menu-toggle auto-hide="false">
                    @if (pageConfig?.configuration?.menuVisibility && pageConfig.url) {
                        @if (
                            !(
                                pageConfig.pageId === 'SHOP_MAIN_PRIVATE' &&
                                userPreferencesService.userPreferences()?.currentMode === 'MINI'
                            )
                        ) {
                            <ion-item
                                [routerLink]="pageConfig.url"
                                class="pointer">
                                <ion-label
                                    [ngClass]="{
                                        'menu-item-active': menuItemActive(pageConfig.categories),
                                        'menu-item': !menuItemActive(pageConfig.categories),
                                    }">
                                    {{ pageConfig.title | translate }}
                                </ion-label>
                            </ion-item>
                        }
                    }
                </ion-menu-toggle>
                @if (
                    this.menuService.fetchSubPageConfig(pageConfig.childPageConfigs, roles)?.length > 0 &&
                    pageConfig?.configuration?.menuVisibility &&
                    !pageConfig.url
                ) {
                    <ion-item
                        class="pointer"
                        (click)="
                            pageConfig.configuration.showSubPagesDetailList =
                                !pageConfig.configuration?.showSubPagesDetailList
                        ">
                        <ion-label class="menu-item"> {{ pageConfig.title | translate }} </ion-label>
                        <ion-note
                            slot="end"
                            color="primary"
                            style="font-size: x-large">
                            @if (!pageConfig.configuration?.showSubPagesDetailList) {
                                <ion-icon name="chevron-down"></ion-icon>
                            }
                            @if (pageConfig.configuration?.showSubPagesDetailList) {
                                <ion-icon name="chevron-up"></ion-icon>
                            }
                        </ion-note>
                    </ion-item>
                }
                <ion-menu-toggle auto-hide="false">
                    @for (
                        subPageConfig of pageConfig.childPageConfigs
                            | MenuItemsFilter: roles : configService.frontendConfig().features : configService.config();
                        track subPageConfig.pageId
                    ) {
                        @if (
                            subPageConfig.configuration?.menuVisibility &&
                            subPageConfig.url &&
                            pageConfig.configuration?.showSubPagesDetailList &&
                            pageConfig.childPageConfigs.length !== 0
                        ) {
                            <ion-item
                                [routerLink]="subPageConfig.url"
                                class="pointer">
                                <ion-label
                                    [ngClass]="{
                                        'menu-sub-item-active': router.url.includes(subPageConfig.url),
                                        'menu-sub-item': !router.url.includes(subPageConfig.url),
                                    }">
                                    {{ subPageConfig.title | translate }}
                                </ion-label>
                            </ion-item>
                        }
                    }
                </ion-menu-toggle>
            </span>
        }
        <ion-menu-toggle auto-hide="false">
            @if (roles?.length !== 0 && configService.config()?.configuration?.features?.profile?.enabled) {
                <ion-item
                    class="pointer"
                    [routerLink]="'member/profile'">
                    <ion-label
                        class="menu-item"
                        color="primary">
                        {{ 'PROFILE_TITLE' | translate }}
                    </ion-label>
                </ion-item>
            }
        </ion-menu-toggle>
        <ion-menu-toggle auto-hide="false">
            @if (roles?.length !== 0) {
                <ion-item
                    class="pointer"
                    data-testid="logout-button"
                    (click)="logout()">
                    <ion-label
                        class="menu-item"
                        style="font-weight: bold"
                        color="primary">
                        {{ 'LOGOUT' | translate }}
                    </ion-label>
                </ion-item>
            }
        </ion-menu-toggle>
    </ion-content>
    <ion-footer>
        <ion-menu-toggle>
            <ion-item
                class="pointer"
                (click)="openUserManual()">
                <ion-label> {{ userManualLabel() | translate }}</ion-label>
            </ion-item>
        </ion-menu-toggle>
        @for (
            pageConfig of configService.frontendConfig().generalPageConfigs
                | checkFeaturePipe: configService.frontendConfig().features : configService.config()?.configuration;
            track pageConfig.url
        ) {
            <span (click)="openPage(pageConfig.url)">
                <ion-menu-toggle auto-hide="false">
                    @if (pageConfig?.configuration?.menuVisibility && pageConfig.url) {
                        <ion-item
                            [routerLink]="pageConfig.url"
                            class="pointer">
                            <ion-label
                                [ngClass]="{
                                    'menu-item-active': menuItemActive(pageConfig.categories),
                                    'menu-item': !menuItemActive(pageConfig.categories),
                                }">
                                {{ pageConfig.title | translate }}
                            </ion-label>
                        </ion-item>
                    }
                </ion-menu-toggle>
                @if (pageConfig?.configuration?.menuVisibility && !pageConfig.url) {
                    <ion-item
                        class="pointer"
                        (click)="
                            pageConfig.configuration.showSubPagesDetailList =
                                !pageConfig.configuration.showSubPagesDetailList
                        ">
                        <ion-label class="menu-item"> {{ pageConfig.title | translate }} </ion-label>
                        <ion-note
                            slot="end"
                            color="primary"
                            style="font-size: x-large">
                            @if (!pageConfig.configuration?.showSubPagesDetailList) {
                                <ion-icon name="chevron-down"></ion-icon>
                            }
                            @if (pageConfig.configuration?.showSubPagesDetailList) {
                                <ion-icon name="chevron-up"></ion-icon>
                            }
                        </ion-note>
                    </ion-item>
                }

                <ion-menu-toggle auto-hide="false">
                    @for (
                        subPageConfig of pageConfig.childPageConfigs
                            | checkFeaturePipe
                                : configService.frontendConfig().features
                                : configService.config()?.configuration;
                        track subPageConfig.pageId
                    ) {
                        @if (
                            subPageConfig.configuration?.menuVisibility &&
                            subPageConfig.url &&
                            pageConfig.configuration?.showSubPagesDetailList &&
                            pageConfig.childPageConfigs.length !== 0
                        ) {
                            <ion-item
                                [routerLink]="subPageConfig.url"
                                class="pointer">
                                <ion-label
                                    [ngClass]="{
                                        'menu-sub-item-active': router.url.includes(subPageConfig.categories),
                                        'menu-sub-item': !router.url.includes(subPageConfig.categories),
                                    }">
                                    {{ subPageConfig.title | translate }}
                                </ion-label>
                            </ion-item>
                        }
                    }
                </ion-menu-toggle>
            </span>
        }
        @if (isDebuggingAttributeEnabled) {
            <ion-item>
                <ion-label>Logging</ion-label>
                <ion-toggle (ionChange)="switchLogging($event)"></ion-toggle>
            </ion-item>
        }
        <ion-item lines="none">
            <ion-label
                side="right"
                data-testid="uid-label"
                [copyClipboard]="versionService.udi()"
                class="udi">
                @if (versionService.udi()) {
                    UDI: {{ versionService.udi() }}
                }
            </ion-label>
        </ion-item>
        @if (appConfig && appConfig.developmentStage) {
            @if (appConfig.developmentStage === BuildType.dev) {
                <ion-item color="dev">
                    <ion-label>Dev</ion-label>
                </ion-item>
            }
            @if (appConfig.developmentStage === BuildType.beta) {
                <ion-item color="beta">
                    <ion-label>Beta</ion-label>
                </ion-item>
            }
        }
    </ion-footer>
</ion-menu>
